module.exports = __webpack_public_path__ + "static/media/contactBouteille_hover.43858753.png";